/* eslint-disable */
import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Build from "@material-ui/icons/Build";
import Subject from "@material-ui/icons/Subject";
import FormatPaint from "@material-ui/icons/FormatPaint";
import Code from "@material-ui/icons/Code";
import Dashboard from "@material-ui/icons/Dashboard";
import Timeline from "@material-ui/icons/Timeline";
import Group from "@material-ui/icons/Group";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Muted from "components/Typography/Muted.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Badge from "components/Badge/Badge.jsx";

import projectsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.jsx";

import pocketweb from "assets/img/pocketweb2.png";
import olodolo from "assets/img/olodolo.png";
import orbIntelligence from "assets/img/orbintelligence.png";
import desidate from "assets/img/desidate.png";
import pixada from "assets/img/pixada.png";

function SectionProjects({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      {/* Project 2 START */}
      <div className={classes.projects}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>
                Some of Our Past Products
              </h2>
              <h5 className={classes.description}>
                We have experience in building web apps, iOS apps, and Android apps.
              </h5>
              <div className={classes.sectionSpace} />
            </GridItem>
          </GridContainer>
          <GridContainer>
              <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.kickoffsoftware.pixada"
                  target="_blank"
                >
                  <CardHeader image plain>
                    <img
                      src={pixada}
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url(${pixada})",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.kickoffsoftware.pixada"
                    target="_blank"
                  >
                    <h4 className={classes.cardTitle}>
                      Pixada
                    </h4>
                  </a>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    Pixada uses machine learning to transfer artistic styles to your photos.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="https://www.pocketweb.io"
                  target="_blank"
                >
                  <CardHeader image plain>
                    <img
                      src={pocketweb}
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url(${pocketweb})",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="https://www.pocketweb.io"
                    target="_blank"
                  >
                    <h4 className={classes.cardTitle}>
                      PocketWeb
                    </h4>
                  </a>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    PocketWeb allows you to host websites on your phone.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="http://www.olodolo.com"
                  target="_blank"
                >
                  <CardHeader image plain>
                    <img
                      src={olodolo}
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url(${olodolo})",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="http://www.olodolo.com"
                    target="_blank"
                  >
                    <h4 className={classes.cardTitle}>
                      Olodolo
                    </h4>
                  </a>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    Olodolo allows you to shop on the biggest sites using your cryptocurrency.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="https://www.kickoffintelligence.com"
                  target="_blank"
                >
                  <CardHeader image plain>
                    <img
                      src={orbIntelligence}
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url(${orbIntelligence})",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="https://www.kickoffintelligence.com"
                    target="_blank"
                  >
                    <h4 className={classes.cardTitle}>
                      Kickoff Intelligence
                    </h4>
                  </a>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    Kickoff Intelligence provides real time AI powered Twitter insights and analytics.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="https://desidateapp.com/"
                  target="_blank"
                >
                  <CardHeader image plain>
                    <img
                      src={desidate}
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url(${desidate})",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="https://desidateapp.com/"
                    target="_blank"
                  >
                    <h4 className={classes.cardTitle}>
                      DesiDate
                    </h4>
                  </a>
                  <h6 className={classes.description}>Android App</h6>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    South Asian dating app utilizing location, camera, messaging, and push notifications. 
                  </p>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Project 2 END */}
    </div>
  );
}

export default withStyles(projectsStyle)(SectionProjects);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionProjects.jsx